/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_A1dInputs */

const en_mk_sol_startup_a1d = /** @type {(inputs: Mk_Sol_Startup_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers cross-division questions from the workspace itself: what is stuck, what waits on a decision.`)
};

const id_mk_sol_startup_a1d = /** @type {(inputs: Mk_Sol_Startup_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjawab pertanyaan lintas divisi dari isi workspace: apa yang macet, apa yang menunggu keputusan.`)
};

/**
* | output |
* | --- |
* | "Answers cross-division questions from the workspace itself: what is stuck, what waits on a decision." |
*
* @param {Mk_Sol_Startup_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_a1d = /** @type {((inputs?: Mk_Sol_Startup_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_a1d(inputs)
	return en_mk_sol_startup_a1d(inputs)
});